import { lazy } from "react";


function load(code){
    switch (code) {
        case "invoice-payment/list":
            return lazy(() => import("views/document-payment/list"));
        default:
            return null;
    }
}
export default load;
